"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ContactCardName = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _react = _interopRequireDefault(require("react"));
var _useTheme = require("../../../theme/utils/useTheme");
var _typography = require("../../typography");
var _constants = require("../constants");
var _contactCardTheme = require("../contactCardTheme");
const ContactCardNameStyled = (0, _styled.default)(_typography.TypeRampV2)`
    display: block;
    overflow-wrap: anywhere;

    /* Maybe add space between the name and an info item if that's what comes next */
    + [class*="${_constants.ccdetailitemlabel}"] {
        margin-top: ${_ref => {
  let {
    themeMode
  } = _ref;
  return _contactCardTheme.contactCardTheme.lineSeparation(themeMode);
}};
    }

    /* Add space between the name and an info item if that's what comes next */
    + [class*="${_constants.ccinfoitemlabel}"] {
        margin-top: 12px;
    }

    /* Add space between the name and an action item if that's what comes next */
    + [class*="${_constants.ccactionlabel}"] {
        margin-top: 4px;
    }

    label: ${_constants.ccnamelabel};

    // TODO - remove this when LodestarGlobalStyles contains default font colors per theme.
    // These colors are the same as the defaults, but we included them here since we didn't think
    // new views actually had set the default color yet.
    color: ${_ref2 => {
  let {
    themeMode
  } = _ref2;
  return _contactCardTheme.contactCardTheme.colors.name(themeMode);
}};
`;
const ContactCardName = _ref3 => {
  let {
    children,
    ...rest
  } = _ref3;
  const {
    key
  } = (0, _useTheme.useTheme)();
  const themeMode = key;
  const typeRampVariant = _contactCardTheme.contactCardTypeRampVariants.name(themeMode);
  return (
    /*#__PURE__*/
    // @ts-expect-error variant type is complaining
    _react.default.createElement(ContactCardNameStyled, (0, _extends2.default)({}, rest, {
      variant: typeRampVariant,
      lineClamp: 1,
      themeMode: themeMode
    }), children)
  );
};
exports.ContactCardName = ContactCardName;
//# sourceMappingURL=ContactCardName.js.map